import { createReducer } from '@reduxjs/toolkit'

import { SnackbarMessage, SnackbarOptions } from 'types/GlobalSnackbar'

import * as actions from '../../actions/Snackbar/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface SnackbarType {
  open: boolean
  message: SnackbarMessage | null
  options?: SnackbarOptions
}

const INITIAL_STATE: SnackbarType = {
  open: false,
  message: null,
  options: undefined
}

const snackbarReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.open, (state, action) => {
      state.open = true
      state.message = action.payload.message
      state.options = action.payload.options
    })
    .addCase(actions.close, () => INITIAL_STATE)
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default snackbarReducer
